import React from 'react';
import { Bubble } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';

interface IFileItemActionsProps extends IBaseProps {
  previewTipsVisible: true | undefined;
  copyTips: string;
  copyTipsVisible: true | undefined;
  onPreview?: () => void;
  onDownload?: () => void;
  onShare?: () => void;
}

const FileItemActions: React.FC<IFileItemActionsProps> = (props) => {
  const {
    previewTipsVisible,
    copyTips,
    copyTipsVisible,
    onPreview,
    onDownload,
    onShare,
  } = props;

  return (
    <ul className="dbg-common-file-item__file-action-list">
      <li className="dbg-common-file-item__file-action-item">
        <Bubble
          key={`action-preview-bubble-${previewTipsVisible}`}
          dark
          content="Preview"
          visible={previewTipsVisible}
        >
          <span
            className="dbg-common-file-item__file-action-icon-wrapper"
            onClick={(e) => {
              e.stopPropagation();
              onPreview?.();
            }}
          >
            <SvgIcon type="open-eyes" />
          </span>
        </Bubble>
      </li>
      <li
        style={{ top: -2 }}
        className="dbg-common-file-item__file-action-item"
      >
        <Bubble dark content="Download">
          <span
            className="dbg-common-file-item__file-action-icon-wrapper"
            onClick={(e) => {
              e.stopPropagation();
              onDownload?.();
            }}
          >
            <SvgIcon type="download" />
          </span>
        </Bubble>
      </li>
      <li className="dbg-common-file-item__file-action-item">
        <Bubble
          key={`action-copy-bubble-${copyTipsVisible}`}
          dark
          content={copyTips}
          visible={copyTipsVisible}
        >
          <span
            className="dbg-common-file-item__file-action-icon-wrapper"
            onClick={(e) => {
              e.stopPropagation();
              onShare?.();
            }}
          >
            <SvgIcon type="share-link" />
          </span>
        </Bubble>
      </li>
    </ul>
  );
};

export default FileItemActions;
